import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import { committeeList } from "Apis/committees";

export const TrusteeContext = createContext();

export const TrusteeContextProvider = ({ children }) => {
  const [editData, setEditData] = useState([]);
  const [trusteeTagList, setTrusteeTagList] = useState([]);

  const handleTrusteeList = async () => {
    let response = await committeeList();
    if (response?.status === 200) {
      if (response?.status === 200) {
        const trusteeData = response?.data?.data?.rows?.map((trustee) => ({
          label: trustee?.tag,
          value: trustee?.id,
        }));
        setTrusteeTagList(trusteeData);
      }
    }
  };

  return (
    <TrusteeContext.Provider
      value={{
        editData,
        setEditData,
        trusteeTagList,
        handleTrusteeList,
      }}
    >
      {children}
    </TrusteeContext.Provider>
  );
};

export default TrusteeContextProvider;
TrusteeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
